/* eslint-disable */
import helper from './validator/utils/helper';

export default class {
  constructor(el) {
    this.element = el;
    this.label = this.element.querySelector('[data-role="label"]');
    this.line = this.element.querySelector('[data-role="line"]');
    this.rulesElements = Array.from(this.element.querySelectorAll('[data-role*="rule"]'));
  }

  validate(str) {
    let strength = { level: 'weak', label: 'Weak' };
    if (helper.isPasswordMiddle(str)) strength = { level: 'medium', label: 'Medium' };
    if (helper.isPasswordStrong(str)) strength = { level: 'strong', label: 'Strong' };
    $(this.label).text(strength.label);
    $(this.line).attr('data-strength', strength.level);
    this.rulesElements.forEach((el) => {
      const type = el.dataset.type;
      let isValid = false;
      switch (type) {
        case 'length': {
          isValid = helper.isPasswordLength(str);
          break;
        }
        case 'lowercase': {
          isValid = helper.hasLowercase(str);
          break;
        }
        case 'uppercase': {
          isValid = helper.hasUppercase(str);
          break;
        }
        case 'number': {
          isValid = helper.hasNumber(str);
          break;
        }
        case 'symbols': {
          isValid = !helper.containSpecialSymbols(str);
          break;
        }
      }
      $(el).toggleClass('is-valid', isValid);
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/form/password-strength.js